import VideoPlayer from "../../components/VideoPlayer/VideoPlayer";
import "./VideosPage.scss";

function VideosPage() {
  return (
    <div>
      <VideoPlayer />
    </div>
  );
}

export default VideosPage;
